import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TargetsListHelperService } from '../../../../_helpers/list-services/targets-list-helper.service';
import { DropDownListElement } from '../../../../shared/utility/drop-down-list-element';
import { LearnerJourneyTarget } from '../../../../_models/timeline-models/learner-journey-target';
import { LearningSectionFlowControlHelperService } from '../../../../_helpers/learning-section-flow-control-helper/learning-section-flow-control-helper.service';
import { TargetSection } from '../../../../_models/timeline-models/section-models/target-section.model';
import { BaseLearningSectionComponent } from '../../../../shared/learning-section/base-learning-section/base-learning-section.component';
import { SuccessModalHelperService } from '../../../../_helpers/success-modal-helper/success-modal-helper.service';
import { TimelineSectionsService } from '../../../../_services/timeline-sections/timeline-sections.service';
import { TimelineSectionStatus } from '../../../../_models/timeline-models/timeline-section-status.enum';
import { ErrorModalHelperService } from '../../../../_helpers/error-modal-helper/error-modal-helper.service';
import { BandingsService } from '../../../../_services/shared/bandings.service';

@Component({
    selector: 'targets-section',
    templateUrl: './targets-section.component.html',
    styleUrls: ['./targets-section.component.css'],
    standalone: false
})
export class TargetsSectionComponent extends BaseLearningSectionComponent {
  
  @Input() timelineSection: TargetSection = new TargetSection();
  public targetList: LearnerJourneyTarget[] = [];
  public targetTypeList: DropDownListElement[] = [];

  constructor(protected readonly targetsListHelperService: TargetsListHelperService,
    protected readonly bandingService: BandingsService,
    protected readonly flowHelperService: LearningSectionFlowControlHelperService,
    public dialog: MatDialog,
    private successModalHelper: SuccessModalHelperService,
    private timelineSectionService: TimelineSectionsService,
    private errorModalHelper: ErrorModalHelperService
  ) {
    super(flowHelperService, dialog);
    this.targetTypeList = targetsListHelperService.getTargetTypeList();
    this.sectionTitle = 'Target';
    bandingService.getBandingsList().subscribe(data => {
      this.targetList = data;
    });
  }

  public learnerJourneyDescription(): string {
    if (this.timelineSection.currentTarget) {
      let target = this.targetList.find(target => {
        return target.text === this.timelineSection.currentTarget;
      });
      if (target && target.furtherInformation) {
        return target.furtherInformation;
      }
    }
    return '';
  }

  public currentTargetVisible(): boolean {
    return this.timelineSection.targetType === 'Both' || this.timelineSection.targetType === 'Banding';
  }

  public assessmentTargetVisible(): boolean {
    return this.timelineSection.targetType === 'Both' || this.timelineSection.targetType === 'Assessment';
  }
  
  validate(): boolean {
    let sectionDate = new Date(this.timelineSection.sectionDate)
    sectionDate.setHours(0, 0, 0, 0);
    return sectionDate >= this.minSectionDate;
  }
 
  public save(dialogRef: MatDialogRef<any>): void {
    if (this.validate()) {
      let oldStatus = this.timelineSection.status;
      this.timelineSection.status = TimelineSectionStatus.Saved;
      this.postMerge(oldStatus);
    }
  }

  public delete(dialogRef: MatDialogRef<any>): void {
      this.timelineSectionService.deleteTargetSection(this.timelineSection).subscribe((response) => {
      });
  }
  
  public unlock(dialogRef: MatDialogRef<any>): void {
    let oldStatus = this.timelineSection.status;
    this.timelineSection.status = TimelineSectionStatus.Unlock;
    this.postMerge(oldStatus);
  }
  
  public submit(dialogRef: MatDialogRef<any>): void {
    if (this.validate()) {
      let oldStatus = this.timelineSection.status;
      this.timelineSection.status = TimelineSectionStatus.Submitted;
      this.postMerge(oldStatus);
    }
  }
  
  public approve(dialogRef: MatDialogRef<any>): void {
    let oldStatus = this.timelineSection.status;
    this.timelineSection.status = TimelineSectionStatus.Approved;
    this.postMerge(oldStatus);
  }
  
  public reject(dialogRef: MatDialogRef<any>): void {
    let oldStatus = this.timelineSection.status;
    this.timelineSection.status = TimelineSectionStatus.Rejected;
    this.postMerge(oldStatus);
  }

  private postMerge(oldStatus: TimelineSectionStatus): void {
    this.timelineSectionService.mergeTargetSection(this.placementId, this.students.map(s => s.studentId), this.subject, this.timelineSection).subscribe((response: TargetSection) => {
      this.timelineSection = response;
      this._sectionStatusUpdated.next(response.status);
      this.successModalHelper.show(this.timelineSection.status + " successfully");
    }, error => {
      console.error(error);
      this.errorModalHelper.show(error.message, error);
      this.timelineSection.status = oldStatus;
    });
  }

}
